import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';

const AddressAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const returnTo = location.state?.returnTo;
  const product = location.state?.product;
  const cartIds = location.state?.cartIds || [];

  // Flask의 input name들과 동일하게 상태 관리
  const [formData, setFormData] = useState({
    receiver_name: '',
    receiver_phone: '',
    address: '',
    detail_address: '',
    is_default: false
  });

  // 상세주소 비활성화 상태 관리 (원본: disabled)
  const [isDetailDisabled, setIsDetailDisabled] = useState(true);

  useEffect(() => {
    // Daum 우편번호 API 스크립트 로드
    const script = document.createElement("script");
    script.src = "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  // 카카오 주소 API 실행 (원본: execDaumPostcode)
  const handleAddressSearch = () => {
    new window.daum.Postcode({
      oncomplete: (data) => {
        setFormData((prev) => ({ ...prev, address: data.address }));
        setIsDetailDisabled(false); // 주소 입력 시 상세주소 활성화
      }
    }).open();
  };

  // 폼 제출 (원본: action="{{ url_for('address.address_add') }}" method="POST")
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Flask 백엔드 API에 POST 요청
      const res = await axios.post('/api/address/add', formData);
      if (res.data.success) {
        alert("배송지가 추가되었습니다.");
        navigate('/address/list', {
          state: {
            returnTo,
            product,
            cartIds
          }
        });
      }
    } catch (err) {
      alert("배송지 저장 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className="container mt-4" style={{ maxWidth: '600px' }}>
      <h3 className="mb-4">배송지 추가</h3>

      <form onSubmit={handleSubmit}>
        {/* 수령인 이름 */}
        <div className="form-floating mb-3" style={styles.floatingGroup}>
          <input
            type="text"
            className="form-control"
            id="receiver_name"
            placeholder="이름"
            required
            style={styles.input}
            onChange={(e) => setFormData({ ...formData, receiver_name: e.target.value })}
          />
          <label htmlFor="receiver_name">이름</label>
        </div>

        {/* 전화번호 */}
        <div className="form-floating mb-3" style={styles.floatingGroup}>
          <input
            type="text"
            className="form-control"
            id="receiver_phone"
            placeholder="전화번호"
            required
            style={styles.input}
            onChange={(e) => setFormData({ ...formData, receiver_phone: e.target.value })}
          />
          <label htmlFor="receiver_phone">전화번호</label>
        </div>

        {/* 주소 (클릭 시 API 실행) */}
        <div className="form-floating mb-3" style={styles.floatingGroup}>
          <input
            type="text"
            className="form-control"
            id="sample5_address"
            placeholder="주소"
            required
            readOnly
            style={{ ...styles.input, cursor: 'pointer' }}
            value={formData.address}
            onClick={handleAddressSearch}
          />
          <label htmlFor="sample5_address">주소</label>
        </div>

        {/* 상세주소 */}
        <div className="form-floating mb-3" style={styles.floatingGroup}>
          <input
            type="text"
            className="form-control"
            id="detailAddress"
            placeholder="상세주소"
            disabled={isDetailDisabled}
            style={styles.input}
            value={formData.detail_address}
            onChange={(e) => setFormData({ ...formData, detail_address: e.target.value })}
          />
          <label htmlFor="detailAddress">상세주소</label>
        </div>

        {/* 기본 배송지 여부 */}
        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="is_default"
            checked={formData.is_default}
            onChange={(e) => setFormData({ ...formData, is_default: e.target.checked })}
          />
          <label className="form-check-label" htmlFor="is_default">
            기본 배송지로 설정
          </label>
        </div>

        <div className="text-end">
          <button type="submit" className="btn btn-primary" style={styles.btnPrimary}>저장</button>
          <button 
            type="button" 
            className="btn btn-secondary" 
            style={styles.btnSecondary}
            onClick={() =>
              navigate('/address/list', {
                state: {
                  returnTo,
                  product,
                  cartIds
                }
              })
            }
          >
            취소
          </button>
        </div>
      </form>
    </div>
  );
};

// Bootstrap floating label 스타일을 React 내에서 재현하기 위한 스타일
const styles = {
  floatingGroup: { position: 'relative' },
  input: {
    width: '100%',
    height: '58px',
    padding: '1.625rem 0.75rem 0.625rem',
    fontSize: '1rem',
    border: '1px solid #ced4da',
    borderRadius: '0.25rem',
    display: 'block'
  },
  btnPrimary: {
    padding: '8px 24px',
    backgroundColor: '#007bff',
    borderColor: '#007bff',
    color: '#fff',
    borderRadius: '4px',
    marginRight: '8px',
    cursor: 'pointer'
  },
  btnSecondary: {
    padding: '8px 24px',
    backgroundColor: '#6c757d',
    borderColor: '#6c757d',
    color: '#fff',
    borderRadius: '4px',
    cursor: 'pointer'
  }
};

export default AddressAdd;